/* descriptiveStatisticsOptionsSlice.ts */

/* Redux-Toolkit */
import {
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";

/* Interfaces */
import { DescriptiveStatisticsOptionsProps } from "src/shared/interfaces/insights-filter/InsightsFilterOptions";

const initialState: DescriptiveStatisticsOptionsProps = {
  showNoValueEntries: false,
};

export const descriptiveStatisticsOptionsSlice = createSlice({
  name: "descriptiveStatisticsOptions",
  initialState,
  reducers: {
    setShowNoValueEntries: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.showNoValueEntries = action.payload;
    },
  },
});

/* Actions */
export const { setShowNoValueEntries } =
  descriptiveStatisticsOptionsSlice.actions;

/* Reducer */
export default descriptiveStatisticsOptionsSlice.reducer;
